// extracted by mini-css-extract-plugin
export default {"gemContainer":"Gems_gemContainer__4mniN"};